import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ToolOutlinedSvg from "@ant-design/icons-svg/es/asn/ToolOutlined";
import AntdIcon from "../components/AntdIcon";
var ToolOutlined = function ToolOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ToolOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ToolOutlined.displayName = 'ToolOutlined';
}
export default /*#__PURE__*/React.forwardRef(ToolOutlined);